import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import config from '../Componentes/config';

const MySwal = withReactContent(Swal);

const ModalChangelog = () => {
    const [changelog, setChangelog] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        axios.get(`${config.API_URL}/changelog`)
            .then(res => {
                const data = res.data;

                if (data.length === 0) return;

                const ultimoID = data[0].ID; // Suponiendo que 'id' es el campo clave
                const ultimoVisto = localStorage.getItem('changelogUltimoVisto');

                // Solo mostrar si hay uno nuevo
                if (parseInt(ultimoVisto) !== ultimoID) {
                    setChangelog(data);
                    mostrarModal(data, ultimoID);
                }
            })
            .catch(() => {
                console.error('Error al cargar changelog');
            });
    }, []);

   const mostrarModal = (data, ultimoID) => {
    const registro = data[0];

    const items = registro.Descripcion
        ? registro.Descripcion.split('|')
        : [];

    const listaHTML = items.map((item, index) => `
        <li style="margin-bottom: 10px; line-height: 1.6;">${item.trim()}</li>
    `).join('');

    MySwal.fire({
        title: `<h2 style="font-size: 22px; margin-bottom: 10px;">🆕 Novedades del sistema - Versión ${registro.Version}</h2>`,
        html: `
            <div style="text-align: left; font-size: 16px; width: 100%; max-width: 100%;">
                <p><strong>📅 Fecha:</strong> ${new Date(registro.Fecha).toLocaleDateString()}</p>
                <p><strong>📌 Título:</strong> ${registro.Titulo}</p>
                <hr style="margin: 15px 0;">
                <p style="font-weight: bold;">🔽 Detalles:</p>
                <ol style="padding-left: 20px; font-size: 15px;">
                    ${listaHTML}
                </ol>
            </div>
        `,
        width: '600px',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#3085d6',
        didClose: () => {
            localStorage.setItem('changelogUltimoVisto', ultimoID);
        }
    });
};

    return null; // no renderiza nada visual
};

export default ModalChangelog;
